export async function asyncForEach<T>(
  array: T[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: (item: T, index: number, array: T[]) => any
) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}
